// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__hgEhp","dot":"Loading_dot__+AsLU","wave":"Loading_wave__SJboZ"};